import { BaseOptionModel } from './base-option-model';

export interface UndercutDegreeOption extends BaseOptionModel<number> {}
